import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Subtitle({ className, ...rest }) {
    return _jsx("p", { className: cn("fwfa-subtitle", className), ...rest });
}
//# sourceMappingURL=Subtitle.js.map